import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var Barcode = function Barcode(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "20",
    viewBox: "0 0 25 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23 19.006c0 .548.382.994.85.994.473 0 .85-.446.85-.994V.992c0-.548-.38-.992-.85-.992-.473 0-.85.444-.85.992v18.014zM20.114 16.5a.5.5 0 0 0 1 0V.498a.5.5 0 0 0-1 0V16.5zm-3.585-.508c0 .558.38 1.007.85 1.007.472 0 .85-.451.85-1.007V1.006c0-.558-.381-1.006-.85-1.006-.472 0-.85.45-.85 1.006v14.986zm-2.886.508a.5.5 0 0 0 1 0V.498a.5.5 0 0 0-1 0V16.5zm-3.586-.508c0 .558.38 1.007.85 1.007.473 0 .85-.451.85-1.007V1.006c0-.558-.38-1.006-.85-1.006-.472 0-.85.45-.85 1.006v14.986zm-3.586 0c0 .558.381 1.007.85 1.007.473 0 .85-.451.85-1.007V1.006C8.171.448 7.79 0 7.321 0c-.471 0-.85.45-.85 1.006v14.986zm-2.885.508a.5.5 0 0 0 1 0V.498a.498.498 0 0 0-.5-.498c-.268 0-.5.222-.5.498V16.5zM0 19.006c0 .548.382.994.85.994.473 0 .85-.446.85-.994V.992C1.7.444 1.32 0 .85 0 .377 0 0 .444 0 .992v18.014zM14.5 19h6.392v-1H14.5v1zM11 19h2v-1h-2v1zm-7 0h4v-1H4v1z"
  }));
};
export default Barcode;